import axios from '../config/axios'
import MailTemplate from '../models/MailTemplate'

export const findAll = () => axios.get<MailTemplate[]>('api/mail-templates')

export const update = (mailTemplate: MailTemplate) =>
  axios.put<MailTemplate>(`api/mail-templates/${mailTemplate.id}`, mailTemplate)

export default { findAll, update }
